/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionStateDTO } from './SubscriptionStateDTO';
import {
    SubscriptionStateDTOFromJSON,
    SubscriptionStateDTOFromJSONTyped,
    SubscriptionStateDTOToJSON,
} from './SubscriptionStateDTO';
import type { WorkspaceModeDTO } from './WorkspaceModeDTO';
import {
    WorkspaceModeDTOFromJSON,
    WorkspaceModeDTOFromJSONTyped,
    WorkspaceModeDTOToJSON,
} from './WorkspaceModeDTO';

/**
 * 
 * @export
 * @interface WorkspaceStatusDTO
 */
export interface WorkspaceStatusDTO {
    /**
     * 
     * @type {WorkspaceModeDTO}
     * @memberof WorkspaceStatusDTO
     */
    mode: WorkspaceModeDTO;
    /**
     * 
     * @type {Date}
     * @memberof WorkspaceStatusDTO
     */
    trialEndDate?: Date;
    /**
     * 
     * @type {SubscriptionStateDTO}
     * @memberof WorkspaceStatusDTO
     */
    subscription?: SubscriptionStateDTO;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceStatusDTO
     */
    monitoringSecondsAvailable?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceStatusDTO
     */
    storageBytesLimit: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceStatusDTO
     */
    storageBytesAvailable: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceStatusDTO
     */
    activeProjectsUsage: number;
}



/**
 * Check if a given object implements the WorkspaceStatusDTO interface.
 */
export function instanceOfWorkspaceStatusDTO(value: object): value is WorkspaceStatusDTO {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('storageBytesLimit' in value) || value['storageBytesLimit'] === undefined) return false;
    if (!('storageBytesAvailable' in value) || value['storageBytesAvailable'] === undefined) return false;
    if (!('activeProjectsUsage' in value) || value['activeProjectsUsage'] === undefined) return false;
    return true;
}

export function WorkspaceStatusDTOFromJSON(json: any): WorkspaceStatusDTO {
    return WorkspaceStatusDTOFromJSONTyped(json, false);
}

export function WorkspaceStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceStatusDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': WorkspaceModeDTOFromJSON(json['mode']),
        'trialEndDate': json['trialEndDate'] == null ? undefined : (new Date(json['trialEndDate'])),
        'subscription': json['subscription'] == null ? undefined : SubscriptionStateDTOFromJSON(json['subscription']),
        'monitoringSecondsAvailable': json['monitoringSecondsAvailable'] == null ? undefined : json['monitoringSecondsAvailable'],
        'storageBytesLimit': json['storageBytesLimit'],
        'storageBytesAvailable': json['storageBytesAvailable'],
        'activeProjectsUsage': json['activeProjectsUsage'],
    };
}

export function WorkspaceStatusDTOToJSON(value?: WorkspaceStatusDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mode': WorkspaceModeDTOToJSON(value['mode']),
        'trialEndDate': value['trialEndDate'] == null ? undefined : ((value['trialEndDate']).toISOString()),
        'subscription': SubscriptionStateDTOToJSON(value['subscription']),
        'monitoringSecondsAvailable': value['monitoringSecondsAvailable'],
        'storageBytesLimit': value['storageBytesLimit'],
        'storageBytesAvailable': value['storageBytesAvailable'],
        'activeProjectsUsage': value['activeProjectsUsage'],
    };
}

